import DiscountValue from "@/modules/marketing/DiscountValue";
export default function DiscountPercentage(){return <DiscountValue percentage/>;}
